<template>
  <div
    class="bar"
    :style="{ '--color': color, '--bgColor': bgColor, '--fillColor': fillColor, '--fillAmount': value < 100 ? value : 100.5 }"
  >{{ value }}%</div>
</template>

<script>

export default {
  name:       "Circlebar",
  components: {
  },

  props: {
    value: {
      type: Number,
      default: 0
    },

    fillColor: {
      type: String,
      default: "#FFFFFF"
    },

    bgColor: {
      type: String,
      default: "#000000"
    },

    color: {
      type: String,
      default: "#FFFFFF"
    }
  },

  data() {
    return {
    };
  },
};
</script>

<style scoped>
  .bar {
    width: 3em;
    height: 3em;
    border-radius: 50%;
    box-shadow: 0 0 0 1px var( --bgColor );
    position: relative;
    background-color: var( --bgColor );
    background-image: conic-gradient( var( --fillColor ) calc( var( --fillAmount ) * 1% ), transparent 0% );
    transition: all .2s linear;
    color: var( --color );
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8em;
	  text-shadow:
      -0   -1px 0 var( --bgColor ),
       0   -1px 0 var( --bgColor ),
      -0    1px 0 var( --bgColor ),
       0    1px 0 var( --bgColor ),
      -1px -0   0 var( --bgColor ),
       1px -0   0 var( --bgColor ),
      -1px  0   0 var( --bgColor ),
       1px  0   0 var( --bgColor ),
      -1px -1px 0 var( --bgColor ),
       1px -1px 0 var( --bgColor ),
      -1px  1px 0 var( --bgColor ),
       1px  1px 0 var( --bgColor ),
      -1px -1px 0 var( --bgColor ),
       1px -1px 0 var( --bgColor ),
      -1px  1px 0 var( --bgColor ),
       1px  1px 0 var( --bgColor );
  }
</style>